// REA-CI/screens/ListingsScreen.tsx

import React, { useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  FlatList,
  Image,
  TouchableOpacity,
} from "react-native";
import { useNavigation } from "@react-navigation/native";
import { FontAwesome } from "@expo/vector-icons";
import { StackNavigationProp } from "@react-navigation/stack";
import { RootStackParamList } from "../App"; // Adjust path if necessary
import { useFavorites } from "../contexts/FavoritesContext";


const ListingsScreen = () => {
  const navigation = useNavigation<StackNavigationProp<RootStackParamList>>();
  const { favorites } = useFavorites();
  

  const propertyData = [
    {
      id: "1",
      title: "2 Niveaux Maison Modern",
      location: "Grand-Bassam, Abidjan, Cote D'ivoire",
      price: "40,000,000 Franc CFA",
      image: require("../assets/default/property_sample1.png"), // Replace with your image
    },
    {
      id: "2",
      title: "Maison Famille",
      location: "Deux-Plateaux, Abidjan, Cote D'ivoire",
      price: "15,000,000 Franc CFA",
      image: require("../assets/default/property_sample2.png"), // Replace with your image
    },
  ];

// // Toggle property favorited status - update so when you unlike it dissapear
// const toggleFavorite = (id: string) => {
//   usefavorites((prevFavorites: string[]) =>
//     prevFavorites.includes(id)
//       ? prevFavorites.filter((fav) => fav !== id)
//       : [...prevFavorites, id]
//   );
// };


  const renderPropertyCard = ({ item }: { item: any }) => (
    <TouchableOpacity
      style={styles.card}
      onPress={() => navigation.navigate("MessagesScreen", { propertyId: item.id })}
    >
      <Image source={item.image} style={styles.cardImage} />
      <View style={styles.cardDetails}>
        <Text style={styles.cardTitle}>{item.title}</Text>
        <Text style={styles.cardSubtitle}>{item.location}</Text>
        <Text style={styles.cardPrice}>{item.price}</Text>
      </View>
      <TouchableOpacity
        style={styles.favoriteButton}
        // onPress={() => toggleFavorite(item.id)}
      >
        <FontAwesome
          name={favorites.includes(item.id) ? "heart" : "heart-o"}
          size={20}
          color={favorites.includes(item.id) ? "red" : "#ffffff"}
        />
      </TouchableOpacity>
    </TouchableOpacity>
  );

  return (
    <View style={styles.container}>
      {/* Greeting Section */}
      <View style={styles.greetingSection}>
        <Text style={styles.greetingText}>Your Listings</Text>
      </View>

      {/* Property Listings */}
      <FlatList
        data={propertyData.filter((property) =>
          favorites.includes(property.id)
        )}
        keyExtractor={(item) => item.id}
        renderItem={renderPropertyCard}
        contentContainerStyle={styles.propertyList}
      />

      {/* Bottom Navigation */}
      <View style={styles.bottomNavigation}>
        <TouchableOpacity
          style={styles.navItem}
          onPress={() => navigation.navigate("BuyerHomeScreen")}
        >
          <FontAwesome name="home" size={24} color="#aaa" />
          <Text style={styles.navText}>Home</Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.navItem}
          onPress={() => navigation.navigate("MapScreen")}
        >
          <FontAwesome name="map" size={24} color="#aaa" />
          <Text style={styles.navText}>Maps</Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.navItem}
          onPress={() => navigation.navigate("ListingsScreen")}
        >
          <FontAwesome name="list" size={24} color="#007BFF" />
          <Text style={styles.navText}>Listings</Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.navItem}
          onPress={() => navigation.navigate("BuyerProfileScreen")}
        >
          <FontAwesome name="user" size={24} color="#aaa" />
          <Text style={styles.navText}>Profile</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F8F8F8",
    paddingTop: 40,
  },
  greetingSection: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    paddingHorizontal: 20,
    marginBottom: 20,
  },
  greetingText: {
    fontSize: 24,
    fontWeight: "bold",
    color: "#333",
  },
  propertyList: {
    paddingHorizontal: 20,
  },
  card: {
    backgroundColor: "#ffffff",
    borderRadius: 10,
    marginBottom: 20,
    overflow: "hidden",
    elevation: 3,
  },
  cardImage: {
    width: "100%",
    height: 150,
  },
  cardDetails: {
    padding: 10,
  },
  cardTitle: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#333",
  },
  cardSubtitle: {
    fontSize: 14,
    color: "#666",
    marginVertical: 5,
  },
  cardPrice: {
    fontSize: 14,
    color: "#007BFF",
    fontWeight: "bold",
  },
  favoriteButton: {
    position: "absolute",
    top: 10,
    right: 10,
    backgroundColor: "rgba(0,0,0,0.5)",
    padding: 8,
    borderRadius: 15,
  },
  bottomNavigation: {
    flexDirection: "row",
    justifyContent: "space-around",
    backgroundColor: "#ffffff",
    paddingVertical: 10,
    borderTopWidth: 1,
    borderTopColor: "#E0E0E0",
  },
  navItem: {
    alignItems: "center",
  },
  navText: {
    fontSize: 12,
    color: "#333",
    marginTop: 5,
  },
});

export default ListingsScreen;